module.exports = __webpack_public_path__ + "img/circadian.c53da908.svg";